import { Link } from "react-router-dom";
import PolicyPage, { P, Section } from "@/components/PolicyPage";

export default function ShippingPolicy() {
  return (
    <PolicyPage eyebrow="Support" title="Shipping Policy" testid="shipping-policy-page"
      intro="Every SYNC piece is made to order. That means two separate stages before it reaches your door: production, then shipping.">
      <div className="grid sm:grid-cols-2 gap-4 mt-10">
        <div className="border border-border p-6" data-testid="shipping-production-card">
          <p className="eyebrow mb-2">Stage 1 — Production</p>
          <p className="font-anton text-3xl uppercase">3–7 business days</p>
          <p className="text-graphite text-sm mt-3 leading-relaxed">Your piece is produced after you order. No overstock, no waste.</p>
        </div>
        <div className="border border-border p-6" data-testid="shipping-transit-card">
          <p className="eyebrow mb-2">Stage 2 — Shipping</p>
          <p className="font-anton text-3xl uppercase">7–10 business days</p>
          <p className="text-graphite text-sm mt-3 leading-relaxed">Shipping time starts after the production period is complete.</p>
        </div>
      </div>

      <Section title="How it works" testid="shipping-how">
        <P>1. You place your order — you'll receive an order confirmation email with your order number.</P>
        <P>2. Production begins: 3–7 business days.</P>
        <P>3. Once production is complete, your order ships. Standard shipping takes 7–10 business days after production.</P>
        <P>4. When your order ships, you'll receive an email with your carrier and tracking number. You can also follow it anytime on our <Link to="/track-order" className="text-signal hover:underline">Track My Order</Link> page.</P>
      </Section>

      <Section title="Shipping rates (United States)" testid="shipping-rates">
        <P>Standard shipping — $5.99. Free on orders over $100.</P>
        <P>Express shipping is also available at checkout for faster transit once production is complete.</P>
      </Section>

      <Section title="International shipping" testid="shipping-intl">
        <P>Canada — $12.99 · United Kingdom — $14.99 · Australia — $16.99. Transit times vary by destination and are shown at checkout. Production time (3–7 business days) applies before any shipment.</P>
      </Section>

      <Section title="Questions?" testid="shipping-questions">
        <P>Reach us at <a href="mailto:info@thesyncwear.com" className="text-signal hover:underline">info@thesyncwear.com</a> — SYNC is based in Atlanta, Georgia, USA.</P>
      </Section>
    </PolicyPage>
  );
}
